<template>
  <div class="main">
    <van-sticky>
      <div class="name">
        <div style="width: 20%;height: 12rem;">
          <img v-if="packageDetail.packageName" :src='packageDetail | picFilter' width="100%" height="100%"
               style="border-radius: 1rem;">
        </div>
        <div style="width: 80%;display: flex;flex-flow: row;">
          <div style="width: 90%;display: flex;flex-flow: column;justify-content: center;">
            <span
                style="font-size: 2.8rem;font-weight: 700;color: #171A32;margin-left: 2rem;">{{
                packageDetail.packageName
              }}</span>
            <span style="font-size: 2.3rem;color: #898989;padding-left: 1em;
                                  word-break: break-all;
                                  overflow: hidden;
                                  text-overflow: ellipsis;
                                  display: -webkit-box;
                                  text-overflow: ellipsis;
                                  -webkit-box-orient: vertical;
                                  -webkit-line-clamp: 2;"
                  @click="showDescription=true">
                    推荐人群：{{ packageDetail.description }}
                    </span>

          </div>
        </div>
      </div>
    </van-sticky>
    <van-popup close-icon="close" closeable v-model="showDescription"
               round position="bottom" :style="{ height: '90%' }">
      <div style="width: 100%;height: 7%"></div>
      <div style="display: flex;justify-content: center;align-items: center;flex-direction: column;">
        <span style="font-size: 3rem;margin-left: 2rem;">{{ packageDetail.packageName }}</span>
        <span style="font-size: 2.3rem;color: #898989;padding: 1em;color: #576b95;">{{
            packageDetail.description
          }}</span>
      </div>
    </van-popup>
    <div style="margin-top: 1.5rem;width: 100%;display: flex;flex-flow: row;margin-bottom: 1.5rem;
    align-items: center;justify-content: space-around;font-size: 2.2rem;color: #409EFF;">
      <div>
        <img src="@/assets/images/safe.svg" style="width: 2.2rem;height: 2.2rem;margin-top: 0.6rem;">
        <span style="margin-left: 0.5rem;">随时退</span>
      </div>
      <div>
        <img src="@/assets/images/safe.svg" style="width: 2.2rem;height: 2.2rem;margin-top: 0.6rem;">
        <span style="margin-left: 0.5rem;">随时改</span>
      </div>
      <div>
        <img src="@/assets/images/safe.svg" style="width: 2.2rem;height: 2.2rem;margin-top: 0.6rem;">
        <span style="margin-left: 0.5rem;">电子报告</span>
      </div>
      <div>
        <img src="@/assets/images/safe.svg" style="width: 2.2rem;height: 2.2rem;margin-top: 0.6rem;">
        <span style="margin-left: 0.5rem;">专家解读</span>
      </div>
    </div>
    <div v-if="userInfo.name">
      <div style="width: 100%;margin-top: 0.5rem;">
        <van-field center name="radio" label="本人" label-width="8rem">
          <template #input>
            <van-radio-group v-model="radio" direction="horizontal" @change="changeUser">
              <van-radio icon-size="16px" :name="userInfo.cardid" v-if="userInfo.cardid">
                {{ userInfo.name | nameFilter }} | {{ userInfo.sexid | sexFilter }} |
                {{ userInfo.cardid | hideCardIdStr }}
              </van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field name="radio" label="亲属" label-width="8rem" v-if="relatives.length > 0">
          <template #input>
            <van-radio-group v-model="radio" @change="changeUser">
              <van-radio icon-size="16px" style="margin-bottom: 1rem;" :name="item.cardid"
                         v-for="item in relatives" v-bind:key="'relatives' + item.name">
                {{ item.name | nameFilter }} | {{ item.sexid | sexFilter }} | {{ item.cardid | hideCardIdStr }}
              </van-radio>
            </van-radio-group>
          </template>
        </van-field>
      </div>
    </div>
    <!--预约日期选择-->
    <dl class="order-dates">
      <dt><h3>可约体检日期</h3>
        <div class="dt-right" @click="showDate = true">全部日期
          <van-icon name="arrow"/>
        </div>
      </dt>
      <dd>
        <ul>
          <li :v-if="orderWeektime.length > 0" v-for="(item,index) in orderWeektime"
              v-bind:key="'orderWeektime' + index"
              :class="{'disabled':item.type,active:item.date == checkDate,actived:item.date == checkedDate}"
              @click="selectWeekDate(item)">
            <p class="day">{{ item.day }}</p>
            <p class="week">{{ item.week }}</p>
            <p class="number">{{ item.number }}</p>
          </li>
        </ul>
        <p style="text-align: center;color: #ff976a;font-size: 2rem">已为您自动定位到最近可约日期</p>
      </dd>
    </dl>
    <div class="order-times" v-if="setBookedTime.length > 0">
      <h3>预约时间段</h3>
      <van-radio-group v-model="setBookedTimeSelected">
        <van-cell-group>
          <van-cell v-for="(item,index) in setBookedTime" v-bind:key="'setBookedTime' + index"
                    :title="item | setBookedTimeFilter"
                    clickable
                    @click="setBookedTimeClick(item)"
                    :value="item.surplus<=0?'已约满':'可约 ' + item.surplus"
                    value-class="pdr10"
                    title-style="font-weight:700"
          >
            <template #right-icon>
              <van-radio :name="item.id" :disabled="item.surplus<=0"/>
            </template>
          </van-cell>
        </van-cell-group>
      </van-radio-group>
    </div>
    <div style="margin-top: 0.5rem;">
      <van-tabs @click="onClick" color="#409EFF" v-model="active">
        <van-tab title="套餐详情"></van-tab>
        <van-tab title="加做项目"></van-tab>
        <van-tab title="预约须知"></van-tab>
        <van-tab title="体检须知"></van-tab>
      </van-tabs>
    </div>

    <div class="group" v-if="active == 0">
      <div
          style="width:100%;height: 40px;display: flex;align-items: center;margin-left: 10px;font-size: 2.3rem;font-weight: 500;">
        <div style="width: 3px;height: 40%;background: #409EFF"></div>
        <span style="margin-left: 6px;">体检项目（{{ total }}项）</span>
      </div>
      <div v-for="(item,index) in packageDetail.basicGroupInfos" v-bind:key="'basicGroupInfos' + index">
        <van-cell v-if="packageItemDec" center style="border-bottom: 1px solid #f5f0f0;"
                  :title=" (index + 1) + '、' + item.groupName"
                  :label="item.clinicalSignIficance | valueFilter"/>
        <van-cell v-if="!packageItemDec" center style="border-bottom: 1px solid #f5f0f0;"
                  :title=" (index + 1) + '、' + item.groupName"
        />
      </div>
    </div>
    <div class="group" style="width: 100%;margin-top: 1rem;padding-bottom: 10rem;" v-if="active == 1">
      <van-cell-group>
        <div style="width: 100%;background-color: #3C8AFF"
             v-for="(item,index)  in checkedGroups" v-bind:key="'checkedGroups1-' + index">
          <van-cell style="border-bottom: 1px solid #f5f0f0;"
                    :title="(index + 1)+ '、' +item.groupname" center>
          </van-cell>
        </div>
      </van-cell-group>
      <van-empty v-if="checkedGroups.length == 0" description="没有加做项目"/>
    </div>
    <div class="group" v-if="active == 2"
         style="color:#646566;font-size: 2.3rem;display: flex;flex-flow: column;align-items: center;padding-bottom: 5rem;">
      <html-panel :url="orderNoticeUrl"></html-panel>
    </div>
    <div class="group" v-if="active == 3"
         style="padding-bottom: 10rem;color:#646566;font-size: 2.3rem;display: flex;flex-flow: column;align-items: center;background: #fff;margin-top: 1rem;">
      <html-panel :url="getPageUrl"></html-panel>
    </div>
    <van-goods-action>、
      <van-goods-action-button type="danger" text="确认更改" @click="checkInfo"
                               color="linear-gradient(to right, #E6A23C, #F56C6C)"/>
    </van-goods-action>
    <van-calendar v-model="showDate" confirm-text="选 择" title="选择体检日期" :min-date="minDate" :max-date="maxDate"
                  @confirm="selectDate" :formatter="formatter" color="#1989fa" ref="allDate"/>
    <van-dialog v-model="showSuccess" theme="round-button" title="恭喜您，更改成功！" @confirm="toCheckInfo">
      <div style="width: 100%;display: flex;margin: 3rem 0;justify-content: center;">
        <div style="width: 90%;font-size: 2.5rem;">
          <p style="text-indent:2.5rem;">您的预约日期已更改，请于 {{ checkDate }} 携带身份证前往 {{ hospitalAddress }}
            进行体检。</p>
        </div>
      </div>
    </van-dialog>

    <van-popup close-icon="close" closeable v-model="showTips" round position="bottom"
               :style="{ height: '75%',paddingTop:'3em',overflowY:'auto' }">
      <van-goods-action style="z-index: 9999">
        <van-goods-action-button type="danger" text="确认预约" @click="makeOrder"
                                 color="linear-gradient(to right, #10E3E9, #409EFF)"/>
      </van-goods-action>
      <!--已选全部套餐-->
      <div class="van-hairline--bottom" style="width: 98%;display: flex;flex-flow: row;margin-top:1em;"
           v-for="(item,index) in checkedPackages" :key="'checkedPackages1-' + index">
        <div style="width: 25%;height: 12rem;display: flex;align-items: center;justify-content: center;">
          <div style="width: 80%;height: 100%;display: flex;justify-content: center;align-items: center;">
            <img v-if="item.packageName" :src='item | picFilter' width="80%" height="80%" style="border-radius: 1rem;">
          </div>
        </div>
        <div style="width: 75%;display: flex;flex-flow: column;">
          <span style="font-size: 2.5rem;
           color: #333;margin-left: 2rem;">
            {{ item.packageName }}
          </span>
          <span style="margin-left: 2rem;font-size: 2.2rem;margin-top: 1rem;color: #666666;">
                <span
                    style="font-size: 2.5rem;margin-top: 1.5rem;color: #999;margin-right: 1rem; text-align: right;display: block"><em
                    style="font-size: .7em">&yen;</em>{{ item.actualPrice }}</span>
              </span>
        </div>
      </div>
      <!--加做项目-->
      <div class="van-hairline--bottom" style="width: 98%;display: flex;flex-flow: row;margin-top:1em;"
           v-for="(item,index) in checkedGroups" :key="'checkedGroups' + index">
        <div style="width: 100%;display: flex;flex-direction: row;justify-content: space-between;padding-bottom: 1em;">
          <span style="font-size: 2.5rem;color: #333;margin-left: 2rem;">
            {{ item.groupName }}
          </span>
          <span style="font-size: 2.5rem;color: #999;margin-right: 1rem;"><em
              style="font-size: .7em">&yen;</em>{{ item.actualPrice }}
          </span>
        </div>
      </div>
      <!---->
      <div v-if="deductionAmount > 0" class="van-hairline--bottom"
           style="width: 98%;display: flex;flex-flow: row;margin-top:1em;">
        <div style="width: 100%;display: flex;flex-direction: row;justify-content: space-between;padding-bottom: 1em;">
          <span style="font-size: 2.5rem;color: #333;margin-left: 2rem;">
            套餐重复项目
          </span>
          <span style="font-size: 2.5rem;color: #999;margin-right: 1rem;">- <em
              style="font-size: .7em">&yen;</em>{{ deductionAmount }}
          </span>
        </div>
      </div>

      <!--总计-->
      <div class="van-hairline--bottom" style="width: 98%;display: flex;flex-flow: row;margin-top:1em;">
        <div style="width: 100%;display: flex;flex-flow: row;justify-content:space-between;align-items: center;">
          <span style="font-size: 2.5rem;
           margin-left: 2rem;font-weight: 500">
            总计：
          </span>

          <span style="font-size: 2.5rem;color: orangered;margin-right: 1rem;"><em style="font-size: .7em">
            &yen;</em>
            <span class="goods-price-int" style="font-size:1.4em">{{ selfAmount.toFixed(2).split('.')[0] }}</span>.
            <span class="goods-price-float">{{ selfAmount.toFixed(2).split('.')[1] }}</span>
          </span>
        </div>
      </div>
      <div style="width: 100%;display: flex;flex-flow: column;margin-top: 1rem;">
        <van-cell-group>
          <van-cell title="体检时间" :value="checkedDateText"/>
        </van-cell-group>
        <van-cell-group>
          <van-cell v-if="showTips" title="姓 名" :value="checkUser.name | nameFilter"/>
        </van-cell-group>
        <van-cell-group>
          <van-cell title="性 别" :value="checkUser.sexid | sexFilter"/>
        </van-cell-group>
        <van-cell-group>
          <van-cell v-if="checkUser.phone" title="手机号码" :value="checkUser.phone | hidePhoneStr"/>
        </van-cell-group>
        <van-cell-group>
          <van-cell title="出生日期" :value="checkUser.birthdate | birthFilter"/>
        </van-cell-group>
        <van-cell-group>
          <van-cell v-if="checkUser.cardid" title="身份证" :value="checkUser.cardid | hideCardIdStr"/>
        </van-cell-group>
      </div>
    </van-popup>
    <van-popup v-model="editUserShow"
               position="right" round
               :style="{ width: '100%', height:'100%',overflow:'hidden',backgroundColor:'#F2F2F2'}">
      <div style="width: 100%;">
        <van-notice-bar mode="closeable"
                        left-icon="volume-o"
                        text="尊敬的用户您好，请您补全身份证信息，这样我们才能提供更精准的服务！"
        />
      </div>
      <van-form style="width: 96%;margin-top: 1rem;" @submit="onSubmit">
        <van-field
            v-model="param.nickname"
            label="昵称"
            placeholder="昵称"/>
        <van-field required
                   v-model="param.name"
                   label="姓名（必填）"
                   placeholder="请填写身份证上的姓名"
                   :rules="[{ required: true, message: '请填写姓名' }]"/>
        <van-field name="radio" label="性别（必填）">
          <template #input>
            <van-radio-group v-model="param.sexid" direction="horizontal">
              <van-radio name="1">男</van-radio>
              <van-radio name="2">女</van-radio>
              <van-radio name="0">未说明</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field required
                   v-model="param.birthdate"
                   label="生日（必填）"
                   placeholder="生日"
                   @click="showAge = true"
                   disabled
                   :rules="[{ required: true, message: '请选择生日' }]"/>
        <van-field name="radio" label="婚姻（选填）">
          <template #input>
            <van-radio-group v-model="param.marital" direction="horizontal">
              <van-radio name="0">未婚</van-radio>
              <van-radio name="1">已婚</van-radio>
              <van-radio name="3">未说明</van-radio>
            </van-radio-group>
          </template>
        </van-field>
        <van-field v-model="param.phone" v-if="type == 'editSelf'" :disabled="phoneDisabled"
                   type="tel"
                   label="手机号（必填）"
                   placeholder="手机号"
        />
        <van-field required v-model="param.cardid"
                   type="text"
                   label="身份证（必填）"
                   placeholder="身份证号"
                   :rules="[{ required: true, message: '请填写身份证号' }]"
                   :error-message="idcardErrorMessage"
                   @blur="idvalidate"
        />
        <van-field v-if="type == 'editSelf'"
                   v-model="param.password"
                   type="text"
                   name="密码"
                   label="密码（选填）"
                   placeholder="登录密码"
        />
        <van-field v-model="param.address" type="text" label="地址（选填）" placeholder="请填写现居住地址"/>
        <!--      <van-field v-model="param.natives" type="text" label="籍贯（选填）" placeholder="请选择籍贯" disabled-->
        <!--                 @click="showNative = true"/>-->
        <div class="footer">
          <van-button round block native-type="submit"
                      color="linear-gradient(to right, #10E3E9, #409EFF)"
                      style="margin-top: 5rem;">提 交
          </van-button>
        </div>
      </van-form>
    </van-popup>
    <!--订单层-->
    <van-popup v-model="chargeWrapperShow" position="bottom"
               :style="{ width: '100%', height:'100%',overflow:'hidden',backgroundColor:'#F2F2F2'}">
      <div style="text-align: center;">
        <van-icon name="success" size="40" color="#07c160"/>
        <h2 style="font-size: 3em;">预约成功</h2>
      </div>
      <div style="width: 100%;display: flex;margin: 3rem 0;justify-content: center;">
        <div style="width: 90%;font-size: 2.5rem;">
          <p style="text-indent:2.5rem;">您的体检订单已经生成，完成支付后，请于 {{ checkDate }} 携带身份证前往
            {{ hospitalAddress }} 进行体检。</p>
        </div>
      </div>
    </van-popup>

  </div>
</template>

<script>
import {HideCardIdStr, HidePhoneStr} from '@/assets/utils/utils.js'
import {encrypt, decrypt} from '../../assets/utils/cryptoUtil.js'
import {Dialog, Toast} from 'vant';
import {
  getExcludeInfoList,
  getGroupInfoList,
  getPackageDetialByPackageId
} from '@/api/module/index'
import {
  getRelatives,
  getUserInfoByPatientid,
  addOrder,
  getOrderCount,
  getSetBookedTime,
  editUserInfo, editRelatives, UpdateOrderDate, getOrderDetailById
} from '@/api/module/user'
import HtmlPanel from "@/components/HtmlPanel";
import {areaList} from "@vant/area-data";


export default {
  name: "index",
  components: {HtmlPanel},
  filters: {
    valueFilter: function (value) {
      if (value == null || value == '') {
        return ''
      } else {
        return value
      }
    },
    nameFilter: function (value) {
      let val = decrypt(value)
      return val
    },
    sexFilter: function (value) {
      if (value == '2') {
        return '女'
      } else if (value == '1') {
        return '男'
      }
    },
    birthFilter: function (value) {
      if (value != null && value != "") {
        return value.substring(0, 10);
      } else {
        return "";
      }
    },
    setBookedTimeFilter: function (value) {
      return value.starttime + ' ~ ' + value.endtime
    },
    hideCardIdStr: function (value) {
      let val = decrypt(value)
      return HideCardIdStr(val)
    },
    hidePhoneStr: function (value) {
      let val = decrypt(value)
      return HidePhoneStr(val)
    }
  },
  data() {
    return {
      packageDetail: {},//体检套餐详情
      checkedPackages: new Array(),//已选套餐
      deductionAmount: 0,
      hospiatlname: window.g.VUE_APP_HOSPITALNAME,
      showMoney: window.g.VUE_APP_SHOW_MONEY,
      hisChargeOpen: window.g.VUE_APP_HIS_CHARGE_OPEN,
      VUE_APP_ISWECHAT: window.g.VUE_APP_ISWECHAT,
      VUE_APP_PAY_ENABLE: window.g.VUE_APP_PAY_ENABLE,
      VUE_APP_PAY_TYPE: window.g.VUE_APP_PAY_TYPE,
      hospitalPhone: window.g.VUE_APP_PHONE,
      hospitalAddress: window.g.VUE_APP_ADDRESS,
      getPageUrl: window.g.VUE_APP_SUB_DIR + '/HtmlPanels/notice_personal.html',
      orderNoticeUrl: window.g.VUE_APP_SUB_DIR + '/HtmlPanels/order_notice_personal.html',
      enterqueue: window.g.VUE_APP_DEFAULT_CHECKLINE,
      orderAddItem: window.g.VUE_APP_ORDER_ADDITEM,
      packageItemDec: window.g.VUE_APP_PACKAGE_ITEMDEC,
      additionalAutoadd: window.g.VUE_APP_ADDITIONAL_AUTOADD,//预约关联项目材料费附加费是否自动关联
      VUE_APP_ENABEL_SPECIFICDISEASE: window.g.VUE_APP_ENABEL_SPECIFICDISEASE,//是否开启专病套餐功能
      showDate: false,
      minDate: new Date(),
      maxDate: new Date(),
      showTime: false,
      currentTime: '08:00',
      showTips: false,
      showSuccess: false,
      showDescription: false,//显示套餐说明
      userInfo: {},//个人信息
      relatives: [],//亲属信息
      radio: undefined,
      active: 0,
      active1: 0,
      checkedDate: undefined,
      checkDate: undefined,//预约体检时间
      checkedDateText: undefined,
      checkUser: {},//体检人信息
      orderCount: [],
      orderArr: new Array(),
      setBookedTime: [],//可约的时间段设置
      setBookedTimeSelected: undefined,
      setBookedTimeSelectedText: '',
      checkTotal: undefined,
      orderWeektime: [],
      showAdd: false,//增加项目
      showDel: false,//删除项目
      deptArr: [],//科室列表
      groups: [],//科室筛选后的组合列表
      datas: [],//所有组合项目
      checkDeptStr: '',//当前选择科室名称
      disableGroup: [],//组合，默认显示，默认禁止
      result: [],//已经选择了的项目ID
      delresult: [],//需要删除的项目ID
      excludeInfoList: [],//组合排斥关联
      checkedGroups: [],//加做项目已经选择了组合对象
      packagePrice: undefined,//已选套餐项目价格
      groupPrice: 0,//已选加做组合价格
      total: 0,//加做项目合计金额
      bookedNo: undefined,//订单id

      //用户信息编辑部分
      phoneErrorMessage: '',//手机号格式错误
      passwordErrorMessage: '',//密码由6位以上的数字与字符组成
      idcardErrorMessage: '',//身份证号码不正确
      date: '',
      areaCode: '',
      areaList,
      showAge: false,
      showNative: false,
      birthMinDate: new Date(1900, 0, 1),
      birthMaxDate: new Date(),
      param: {
        name: '',
        sexid: '',
        marital: '',
        phone: '',
        password: '',
        cardid: '',
        birthdate: '',
        address: '',
        // natives: '',//出生地Patient表没有
      },
      phoneDisabled: true,
      type: 'editSelf',
      editUserShow: false,
      chargeWrapperShow: false,  //订单层
      chargeWrapperData: null,
      overayShow: false, //轮询层
      currentRate: 0,//环形初始值
      initRate: 10, //环形初始目标值
      circleText: "10%", //环形文字
      qrCodeUrl: 'http://www.baidu.com',
      ermsg: '长按二维码支付',
      qrImageUrl: require("@/assets/images/WeChatPay.svg"),
      showSpecificDisease: false,//显示专病套餐
      specificDiseaseDetail: {},//专病套餐详情
      specificDiseaseDetailTitle: '',//专病套餐详情标题
      specificDiseaseDetailShow: false,
      VUE_APP_SETTLEMENTMODE: window.g.VUE_APP_SETTLEMENTMODE, //结算方式 默认按套餐
      defaultPackageList: [],//全部个人套餐数据
      SpecificDiseaseList: [],//专病套餐
      //小球
      ball: {
        el: null,
        show: false,
        imgSrc: require("@/assets/images/package/package-default.jpg")
      },
      showCheckedPackages: false,
      selfAmount: 0,
      checkLine: '1',
      configJson: {},//统一下单返回数据
      openid: '',
      payLoading: false,
    }
  },
  created() {
    if ("5" != this.VUE_APP_SETTLEMENTMODE) {
      this.VUE_APP_SETTLEMENTMODE = "2"
    }
    let _this = this;
    _this.checkDate = this.$route.query.checkDate
    _this.bookedNo = this.$route.query.bookedNo
    _this.timeSlot = this.$route.query.timeSlot
    //套餐ID
    let packageId = this.$route.query.packageId
    if (packageId == null || packageId == undefined || packageId == '') {
      console.log("packageId is null")
      this.$router.push({name: 'orders'})
      return
    }
    if (_this.checkDate == null || _this.checkDate == undefined || _this.checkDate == '') {
      console.log("checkDate is null")
      this.$router.push({name: 'orders'})
      return
    }
    if (_this.bookedNo == null || _this.bookedNo == undefined || _this.bookedNo == '') {
      console.log("bookedNo is null")
      this.$router.push({name: 'orders'})
      return
    }
    // if (_this.timeSlot == null || _this.timeSlot == undefined || _this.timeSlot == '') {
    //   console.log("timeSlot is null")
    //   this.$router.push({name: 'orders'})
    //   return
    // }
    this.getPackageDetail(packageId)
    this.getUserList()
    this.getGroups()


    // this.creatQrCode()


  },
  methods: {
    generateRandomInteger(min, max) {
      return Math.floor(Math.random() * (max - min + 1)) + min;
    },
    //查询预约排班
    getCount(checkLine) {
      var _this = this;
      let params = {
        companyid: "0000",
        companytimes: 1,
        checkline: checkLine == null ? "1" : checkLine,
        institutionid: window.g.VUE_APP_INSTITUTIONID
      }
      getOrderCount(params).then(res => {
        if (res.code == 200) {
          this.orderCount = res.data
          console.log(this.orderCount)
          let currDatetime = ""
          let currDatetimeIsCount = false
          this.orderCount.forEach(item => {
            if (item.womennumber > 0 || item.mennumber > 0) {
              if (item.womennumber - item.alreadywomen > 0 || item.mennumber - item.alreadymen > 0) {
                if (!currDatetimeIsCount && item.bookeddate > this.getNow()) {
                  currDatetime = item.bookeddate
                  currDatetimeIsCount = true
                }
              }
            } else if (item.bookednumber > 0) {
              if (item.bookednumber - item.already) {
                if (!currDatetimeIsCount && item.bookeddate > this.getNow()) {
                  currDatetime = item.bookeddate
                  currDatetimeIsCount = true
                }
              }
            }
            this.orderArr.push(item.bookeddate + '')
          })
          this.maxDate = this.getNextMonth()
          setTimeout(function () {
            if (currDatetime == "") {
              _this.orderWeektime = _this.getWeekTime()
            } else {
              _this.orderWeektime = _this.getWeekTime(currDatetime)
            }
            //设置已预约的日期
            _this.orderWeektime.some(item => {
              if (item.date == _this.checkDate) {
                _this.selectWeekDate(item);
                return true;
              }
            })
          }, 30)
        }
      })
    },
    //查询预约时间段
    getSetBookedTime(bookedDate) {
      bookedDate = bookedDate.replace(RegExp("-", "g"), "")
      let params = {
        bookedDate: bookedDate,
        checkLine: this.checkLine,
        institutionId: window.g.VUE_APP_INSTITUTIONID
      }
      getSetBookedTime(params).then(res => {
        if (res.code == 200) {
          this.setBookedTime = res.data

          // 设置已预约的时间段
          this.setBookedTime.some(item => {
            if (item.id == this.timeSlot) {
              this.setBookedTimeClick(item)
              return true;
            }
          })
        }
      })
    },
    makeOrder() {
      var _this = this
      //判断性别是否符合
      if (this.packageDetail.sexId == '1') {
        //男
        if (this.checkUser.sexid == '0' || this.checkUser.sexid == '2') {
          Toast.fail('您选择的套餐与您选择的体检人性别不符合');
          return
        }
      } else if (this.packageDetail.sexId == '2') {
        //女
        if (this.checkUser.sexid == '0' || this.checkUser.sexid == '1') {
          Toast.fail('您选择的套餐与您选择的体检人性别不符合');
          return
        }
      }
      this.computeAmount()
      let prices = []
      let itemtypes = []
      this.checkedGroups.forEach(item => {
        prices.push(item.actualPrice)
        itemtypes.push(item.itemType)
      })
      //添加订单
      let param = {
        bookedno: this.bookedNo,
        timeslot: this.setBookedTimeSelected,
        checkdate: this.checkDate,
        packageid: this.packageId,
        checkedPackages: this.checkedPackages,
        groupIdList: this.result,
      }
      UpdateOrderDate(param).then(res => {
        if (res.code == 200) {
          console.log("res.data.deptCestriction", res.data.deptCestriction)
          if (res.data.deptCestriction) {
            Dialog.alert({
              title: '温馨提示',
              message: res.data.deptCestriction,
            })
          }

          if (res.data == null || res.data == 0) {
            //不能预约的情况
            Dialog.alert({
              title: '温馨提示',
              message: res.msg,
            })
            return;
          }
          _this.showSuccess = true
        } else {
          //不能预约的情况
          Dialog.alert({
            title: '预约提交失败',
            message: res.msg,
          })
        }
      })
    },

    checkInfo() {
      if (this.checkDate == undefined) {
        Toast.fail('请选择体检时间');
        return
      }
      if (this.setBookedTime.length > 0 && this.setBookedTimeSelected == undefined) {
        Toast.fail('请选择体检时间段');
        return
      }

      //获取体检人信息
      //radio,身份证号码,根据身份证号码确定是哪个体检人员
      if (this.radio == this.userInfo.cardid) {
        //本人
        this.checkUser = this.userInfo
      } else {
        //亲属
        this.relatives.forEach(item => {
          if (item.cardid == this.radio) {
            this.checkUser = item
          }
        })
      }

      if (this.checkUser.sexid == null || this.checkUser.sexid == undefined || this.checkUser.sexid == "" || this.checkUser.sexid == "0"
          || this.checkUser.cardid == null || this.checkUser.cardid == undefined || this.checkUser.cardid == ""
      ) {
        Dialog.alert({
          message: "信息不全，检查性别和身份证设置，请先补全基本信息再预约",
        }).then(() => {
          this.$router.push({name: 'edituser'})
        });
        return;
      }

      this.showTips = true
    },
    formatDate(date) {
      let year = date.getFullYear()
      let month = date.getMonth() + 1
      let day = date.getDate()
      if (month < 10) {
        month = '0' + month
      }
      if (day < 10) {
        day = '0' + day
      }
      return `${year}-${month}-${day}`;
    },
    selectDate(date) {

      // 2024-02-28 ZLS 修复当前日期不可选日期 被选择的问题
      let flag = false
      this.orderWeektime.some(item => {
        if (item.date === this.formatDate(date) && item.type) {
          flag = true
          return true;
        }
      })
      if (flag) {
        return;
      }

      let newDate = new Date()
      this.showDate = false
      // if(this.formatDate(date) == this.formatDate(new Date())){
      //   return;
      // }
      this.checkDate = this.formatDate(date)
      this.checkedDateText = this.checkDate
      this.setBookedTimeSelected = undefined
      this.orderWeektime = this.getWeekTime(this.checkDate)
      this.getSetBookedTime(this.checkDate)
    },
    setBookedTimeClick(item) {
      if (item.surplus > 0) {
        this.setBookedTimeSelected = item.id
        this.checkedDateText = this.checkDate + " " + item.starttime + "~" + item.endtime
      }
    },
    selectWeekDate(item) {
      if (item.type) {
        return;
      }

      this.checkDate = item.date
      this.checkedDateText = this.checkDate
      this.setBookedTimeSelected = undefined
      this.$refs.allDate.reset(new Date(this.checkDate));
      this.getSetBookedTime(this.checkDate)
    },
    getUserList() {
      let _this = this
      this.show = true
      //查询客户和亲属信息
      let param = {
        patientid: this.$encruption(JSON.parse(localStorage.getItem("loginuser")).patientid)
      }
      getRelatives(param).then(res => {
        //2025-07-03 luotong 处理PatientID加密出错导致的出错
        if(res.data == -1 && res.msg === "参数patientid错误"){
          Dialog({
            message: "登录过期，返回重新登录",
            theme: 'round-button',
          }).then(() => {
            window.localStorage.removeItem("loginuser")
            localStorage.removeItem("token")
            this.$router.push({name: 'login'})
          });
        }
        if (res.code == 200) {
          if (res.data == -1) {
            Dialog({
              message: res.msg + ',请立即联系体检中心处理，电话：' + this.hospitalPhone,
              theme: 'round-button',
            });
          } else {
            this.relatives = res.data
            if (this.radio == this.userInfo.cardid) {
              //本人
              this.checkUser = this.userInfo
            } else {
              //亲属
              this.relatives.forEach(item => {
                if (item.cardid == this.radio) {
                  this.checkUser = item
                }
              })
            }
          }
        }
      })
      getUserInfoByPatientid(param).then(res => {
        if (res.code == 200) {
          if (res.data == -1) {
            if (res.msg == "参数patientid错误") {
              Dialog({
                message: "登录过期，返回重新登录",
                theme: 'round-button',
              }).then(() => {
                window.localStorage.removeItem("loginuser")
                localStorage.removeItem("token")
                this.$router.push({name: 'login'})
              });
            } else {
              Dialog({
                message: res.msg + ',请立即联系体检中心处理，电话：' + this.hospitalPhone,
                theme: 'round-button',
              });
            }
          } else {
            this.userInfo = res.data
            if (this.userInfo.cardid == null || this.userInfo.cardid == undefined || this.userInfo.cardid == '') {
              Toast.fail('请您完善个人信息！');
              this.param = this.userInfo
              this.param.name = decrypt(this.param.name)
              if (this.param.cardid != null) {
                this.param.cardid = decrypt(this.param.cardid)
              }
              this.param.phone = decrypt(this.param.phone)
              if (this.param.birthdate) {
                this.param.birthdate = this.param.birthdate.substring(0, 10)
              }
              this.editUserShow = true
            } else {
              this.radio = this.userInfo.cardid
            }
          }
        }
      })
    },
    //获取套餐详情
    getPackageDetail(packageId) {
      let _this = this
      getPackageDetialByPackageId({packageId: packageId}).then(res => {
        if (res.code == 200) {
          _this.packageDetail = res.data
          _this.checkLine = _this.packageDetail.checkLine
          _this.checkedPackages.push(res.data)
          _this.selfAmount = _this.packageDetail.actualPrice
          if (_this.packageDetail != null) {
            if (_this.packageDetail.basicGroupInfos != undefined) {
              _this.total = _this.packageDetail.basicGroupInfos.length
            }
            this.getCount(_this.packageDetail.checkLine)
          }
        } else {
          Toast.fail('服务器出错！');
        }
      })
      // 查询手动添加的项目列表
      let param = {
        bookedno: _this.bookedNo
      }
      getOrderDetailById(param).then(res => {
        if (res.code == 200) {
          res.data.groups.forEach(item => {
            if (item.category == "2") {
              _this.checkedGroups.push(item);
              _this.result.push(item.groupid)
            }
          })
        }
      })

    },
    detail(item) {
      if (item != '') {
        Dialog.alert({
          title: '检查意义',
          message: item,
        }).then(() => {
        });
      }
    },
    toCheckInfo() {
      this.$router.push({name: 'orders'})
    },
    formatter(day) {
      let year = day.date.getFullYear();
      let month = day.date.getMonth() + 1;
      let date = day.date.getDate();
      if (month < 10) {
        month = '0' + month
      }
      if (date < 10) {
        date = '0' + date
      }
      let days = year + '-' + month + '-' + date
      this.orderCount.forEach(item => {
        if (item.bookeddate == days) {
          if (item.status == '0') {
            day.bottomInfo = '不可约';
            day.type = "disabled"
          } else if (item.status == '1') {
            let personCount = 0;
            if (parseInt(item.mennumber) > 0 || parseInt(item.womenmumber) > 0) {
              if (this.userInfo.sexid == "1") {
                personCount = parseInt(item.mennumber) - parseInt(item.alreadymen);
              }
              if (this.userInfo.sexid == "2") {
                personCount = parseInt(item.womennumber) - parseInt(item.alreadywomen);
              }
            } else {
              personCount = parseInt(item.bookednumber) - parseInt(item.already);
            }
            if (personCount <= 0) {
              day.bottomInfo = '已约满';
              day.type = "disabled"
            } else {
              if (days <= this.getNow()) {
                day.type = "disabled"
                day.bottomInfo = '不可约';
              } else {
                day.bottomInfo = '余 ' + personCount;
              }
            }
          }
        }
      })
      //将所有的没有排期的设置为休息日

      if (!this.orderArr.includes(days)) {
        let nextMonthStr = ""
        let nextMonth = this.getNextMonth()
        let nextM = nextMonth.getMonth() + 1
        let nextD = nextMonth.getDate()
        if (nextM < 10) {
          nextM = '0' + nextM
        }
        if (nextD < 10) {
          nextD = '0' + nextD
        }
        nextMonthStr = nextMonth.getFullYear() + '-' + nextM + '-' + nextD
        //已经过去的时间不显示文字
        if (days >= this.getNow() && days <= nextMonthStr) {
          day.bottomInfo = '不可约';
          day.type = "disabled"
        }
      }
      return day;
    },
    onClick(name) {
      if (name == '0') {
        this.active = 0
      } else if (name == '1') {
        this.active = 1
        // this.checkedGroups = []
        this.groupPrice = 0
      } else if (name == '2') {
        this.active = 2
      } else if (name == '3') {
        this.active = 3
      }
    },
    getNextMonth() {
      let d = new Date();
      d.setMonth(d.getMonth() + 1);//月份只显示当前月，如果要显示下一月+1
      d.setDate(d.getDate() - 1);
      let yy1 = d.getFullYear();
      let mm1 = d.getMonth();
      let dd1 = d.getDate();
      return new Date(yy1, mm1, dd1)
    },
    getNow() {
      let d = new Date();
      let yy1 = d.getFullYear();
      let mm1 = d.getMonth() + 1;
      if (mm1 < 10) {
        mm1 = '0' + mm1
      }
      let dd1 = d.getDate();
      if (dd1 < 10) {
        dd1 = '0' + dd1
      }
      return yy1 + '-' + mm1 + '-' + dd1
    },
    getWeekTime(dateParam) {
      console.log("dateParam", dateParam)
      // var new_Date = new Date(2021,11,10) //获取指定日期当周的一周日期
      var new_Date = new Date() //获取本周一周日期
      if (this.orderArr.length > 0) {
        new_Date = new Date(this.orderArr[0])
      }
      if (dateParam != undefined) {
        new_Date = new Date(dateParam)
      }
      var timesStamp = new_Date.getTime();
      var currenDay = new_Date.getDay();
      var dates = [];
      for (var i = 0; i < 7; i++) {
        var das = new Date(timesStamp + 24 * 60 * 60 * 1000 * (i - (currenDay + 6) % 7));
        // var dasStr = das.toLocaleDateString();
        let year = das.getFullYear();
        let month = das.getMonth() + 1;
        let date = das.getDate();
        if (month < 10) {
          month = '0' + month
        }
        if (date < 10) {
          date = '0' + date
        }
        let days = year + '-' + month + '-' + date
        var weekObj = {};
        weekObj.index = i
        weekObj.date = days;
        // das.replace(/[年月]/g, '.').replace(/[日上下午]/g, '');
        weekObj.day = (das.getMonth() + 1) + '/' + das.getDate();
        weekObj.week = this.getWeekName(das.getDay());
        weekObj.type = true;
        weekObj.number = '不可约'
        if (das.getDay() == 6 || das.getDay() == 0) {
          weekObj.type = true;
          weekObj.number = '不可约'
        }
        if (this.orderArr.length > 0) {
          this.orderCount.forEach(item => {
            if (item.bookeddate == days) {
              if (item.status == '0') {
                weekObj.number = '不可约'
                weekObj.type = true
              } else if (item.status == '1') {
                let personCount = 0;
                if (parseInt(item.mennumber) > 0 || parseInt(item.womennumber) > 0) {
                  if (this.userInfo.sexid == "1") {
                    personCount = parseInt(item.mennumber) - parseInt(item.alreadymen);
                  }
                  if (this.userInfo.sexid == "2") {
                    personCount = parseInt(item.womennumber) - parseInt(item.alreadywomen);
                  }
                } else {
                  personCount = parseInt(item.bookednumber) - parseInt(item.already);
                }
                if (personCount <= 0) {
                  weekObj.number = '已约满';
                  weekObj.type = true
                } else {
                  if (days <= this.getNow()) {
                    weekObj.type = true
                    weekObj.number = '不可约';
                  } else {
                    weekObj.type = false
                    weekObj.number = '余 ' + personCount;
                  }
                }
              }
            }
          })
        }
        dates.push(weekObj);
      }
      return dates;
    },
    getWeekName(day) {
      switch (day) {
        case 1: {
          return "周一";
          break;
        }
        case 2: {
          return "周二";
          break;
        }
        case 3: {
          return "周三";
          break;
        }
        case 4: {
          return "周四";
          break;
        }
        case 5: {
          return "周五";
          break;
        }
        case 6: {
          return "周六";
          break;
        }
        case 0: {
          return "周日";
          break;
        }
        default: {
          return "";
        }
      }
    },
    //获取所有项目
    getGroups() {
      let param = {}
      getGroupInfoList(param).then(res => {
        if (res.code == 200) {
          //根据科室进行分类
          this.datas = res.data
          res.data.forEach(item => {
            if (this.deptArr.length > 0) {
              if (!this.deptArr.includes(item.departmentName) && item.departmentName != undefined) {
                this.deptArr.push(item.departmentName)
              }
            } else {
              if (item.departmentName != undefined) {
                this.deptArr.push(item.departmentName)
              }
            }
          })
          res.data.forEach(item => {
            if (item.departmentName == (this.deptArr)[0]) {
              this.groups.push(item)
              this.checkDeptStr = item.departmentName
            }
          })
          this.getExcludes()
          this.checkDept(this.checkDeptStr)
        }
      })
    },
    //切换科室
    checkDept(name) {
      this.groups = []
      this.checkDeptStr = name
      //根据科室名称过滤组合
      this.datas.forEach(item => {
        if (item.departmentName == name) {
          this.groups.push(item)
          this.checkSex()
        }
      })
    },
    //将不适用性别的组合禁用掉
    checkSex() {
      this.disableGroup = []
      //判断性别是否适用
      let userSex = this.userInfo.sexid
      if (userSex == "0") {
        //女
        //过滤男性组合
        this.groups.forEach(item => {
          if (item.sexId == '1' && item.sexId != '0') {
            this.disableGroup.push(item.groupId)
          }
        })
      } else if (userSex == "1") {
        //男
        //过滤女性组合
        this.groups.forEach(item => {
          if (item.sexId == '2' && item.sexId != '0') {
            this.disableGroup.push(item.groupId)
          }
        })
      }
      //将套餐内包含的项目禁用掉
      this.groups.forEach(item => {
        this.checkedPackages.forEach(cp => {
          cp.basicGroupInfos.forEach(jtem => {
            if (item.groupId == jtem.groupId) {
              this.disableGroup.push(item.groupId)
            }
          })
        })
      })
    },
    //获取关联排斥项目
    getExcludes() {
      getExcludeInfoList().then(res => {
        if (res.code == 200) {
          this.excludeInfoList = res.data
        }
      })
    },
    //清空已选项目
    clearGroups() {
      Dialog.confirm({
        title: '提示',
        message: '您确定要清空已选加做项目吗？',
      }).then(() => {
        Toast('已清空已选加做项目');
        // this.result = []
        this.checkedGroups = []
        this.computeAmount()
      }).catch(() => {
        // on cancel
      });
    },
    edit() {
      if (this.type == 'editSelf') {
        let opneid = ''
        let userinfo = JSON.parse(sessionStorage.getItem("userinfo"));
        if (userinfo) {
          opneid = userinfo.opneid
          if (opneid != '' && opneid != undefined) {
            this.param.opneid = opneid
          }
        }
        //身份证、手机号码、密码加密
        let newParam = JSON.parse(JSON.stringify(this.param))
        newParam.cardid = encrypt(newParam.cardid)
        newParam.phone = encrypt(newParam.phone)
        newParam.password = encrypt(newParam.password)
        editUserInfo(newParam).then(res => {
          if (res.code == 200) {
            if (res.data == -1) {
              Toast.fail(res.msg);
            } else {
              let param = this.param

              param.name = encrypt(this.param.name)
              param.cardid = encrypt(this.param.cardid)
              param.phone = encrypt(this.param.phone)

              localStorage.setItem("loginuser", JSON.stringify(param))
              Toast.success('修改成功！');
              this.$router.go(-1);//返回上一层
            }
          }
        })
      } else if (this.type == 'editRelative') {
        this.param.phone = '';
        this.param.password = '';
        //身份证、手机号码、密码加密
        let newParam = JSON.parse(JSON.stringify(this.param))
        newParam.patientid = encrypt(newParam.patientid)
        newParam.cardid = encrypt(newParam.cardid)
        newParam.phone = encrypt(newParam.phone)
        newParam.password = encrypt(newParam.password)
        editRelatives(newParam).then(res => {
          if (res.code == 200) {
            if (res.data == -1) {
              Toast.fail(res.msg);
            } else {
              Toast.success('修改成功！');
              this.$router.go(-1);//返回上一层
            }
          }
        })
      }
    },
    idvalidate() {
      //身份证校验
      // eslint-disable-next-line no-unreachable
      let myreg = /^[1-9]\d{5}(18|19|20)\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/
      if (!myreg.test(this.param.cardid)) {
        this.idcardErrorMessage = '请填写正确的身份证号码'
        return false;
      } else {
        this.idcardErrorMessage = ''
        return true;
      }
    },
    onSubmit() {
      if (this.idvalidate()) {
        this.edit()
      }
    },
    changeUser() {
      if (this.radio == this.userInfo.cardid) {
        //本人
        this.checkUser = this.userInfo
      } else {
        //亲属
        this.relatives.forEach(item => {
          if (item.cardid == this.radio) {
            this.checkUser = item
          }
        })
      }
    },
    //计算金额
    computeAmount() {
      //查看已经选择的组合
      this.chooseGroup = []
      this.groupPrice = 0
      //加做组合
      let groups;
      groups = this.result.filter(item => {
        return !this.disableGroup.includes(item)
      })
      //获取加做组合详情 chooseGroup
      this.datas.forEach(item => {
        groups.forEach(jtem => {
          if (item.groupId == jtem) {
            this.chooseGroup.push(item)
            //加做组合价格 groupPrice
            this.groupPrice = parseFloat(this.groupPrice) + parseFloat(item.actualPrice)
          }
        })
      })
      this.packageamount = 0
      let amount = 0
      let actualAmount = 0;
      let selfAmount = 0
      let unDiscountItems = []
      let discountItems = []
      let unDiscountPrice = 0
      let prevBasicGroupInfos = []
      let deductionAmount = 0
      this.checkedPackages.forEach((item, i) => {
        this.packageamount += item.actualPrice
        item.basicGroupInfos.forEach(gtem => {
          if (i > 0) {
            prevBasicGroupInfos.forEach(jtem => {
              if (gtem.groupId == jtem.groupId) {
                gtem.isDelete = '2'
                deductionAmount += gtem.price
              }
            })
          }
          if (gtem.isDelete == "2") {

          } else {
            amount += gtem.price
          }

          if (gtem.allowDiscount == "1" && gtem.isDelete != "2") {
            discountItems.push(gtem)
          } else {
            unDiscountItems.push(gtem)
            unDiscountPrice += gtem.price
          }
        })
        prevBasicGroupInfos = prevBasicGroupInfos.concat(item.basicGroupInfos)
      })
      //套餐总金额

      this.packageamount = this.packageamount - deductionAmount
      this.deductionAmount = deductionAmount
      this.chooseGroup.forEach(item => {
        amount += item.price
        if (item.allowDiscount == "1") {
          discountItems.push(item)
        } else {
          unDiscountItems.push(item)
          unDiscountPrice += item.price
        }
      })
      this.selfAmount = this.packageamount
      if (amount != 0) {
        selfAmount = this.packageamount + (this.groupPrice)
        this.selfAmount = selfAmount
        actualAmount = selfAmount
        console.log('更新价格前：' + selfAmount)
        console.log('更新价格前：' + actualAmount)
        this.updatePackageGroupsPrice() //更新套餐项目实收价格
        this.floatingPackageGroupsPrice() //抹平套餐价差
      }
      this.amount = amount.toFixed(2)
      this.actualAmount = actualAmount

      console.log("原价金额：" + this.amount)
      console.log("实收金额：" + this.actualAmount)
      console.log("套餐金额：" + this.packageamount)
      console.log("加做金额：" + (this.groupPrice))
      console.log("自付金额：" + this.selfAmount)
      this.checkGroupsPrice() //验证项目实收价格
    },
    //更新套餐项目实收价格
    updatePackageGroupsPrice() {
      this.checkedPackages.forEach(item => {
        //计算每个套餐的实际折扣（去除不允许折扣项目的金额）
        let notAllowDiscountAmount = 0
        item.basicGroupInfos.forEach(gtem => {
          if (gtem.allowDiscount != "1" || gtem.isDelete == "2") {
            notAllowDiscountAmount += gtem.price
          }
        })
        let realDiscount = (item.actualPrice - notAllowDiscountAmount) / (item.price - notAllowDiscountAmount)
        //更新套餐内允许折扣项目的时候金额
        item.basicGroupInfos.forEach(gtem => {
          if (gtem.allowDiscount == "1" && gtem.isDelete != "2") {
            gtem.actualPrice = (gtem.price * realDiscount).toFixed(2)
          }
        })
      })
    },
    //抹平套餐价差
    floatingPackageGroupsPrice() {
      this.checkedPackages.forEach(item => {
        let actualAmount = 0;
        let notAllowDiscountAmount = 0
        let maxIndex = 0
        let maxPrice = 0
        item.basicGroupInfos.forEach((gtem, i) => {
          if (gtem.allowDiscount == "1" && gtem.isDelete != "2") {
            actualAmount += parseFloat(gtem.actualPrice)
            if (parseFloat(gtem.actualPrice) > maxPrice) {
              maxPrice = parseFloat(gtem.actualPrice)
              maxIndex = i
            }
          } else {
            notAllowDiscountAmount += parseFloat(gtem.price)
          }
        })
        if (actualAmount != parseFloat(item.actualPrice - notAllowDiscountAmount)) {
          let diff = parseFloat(item.actualPrice - notAllowDiscountAmount) - actualAmount
          let tempPrice = item.basicGroupInfos[maxIndex].actualPrice;
          item.basicGroupInfos[maxIndex].actualPrice = parseFloat(tempPrice) + diff
        }
      })
    },
    //验证项目实收价格
    checkGroupsPrice() {
      let actualAmount = 0
      this.checkedPackages.forEach((item, pi) => {
        item.basicGroupInfos.forEach((gtem, i) => {
          if (gtem.isDelete != "2") {
            actualAmount += parseFloat(gtem.actualPrice)
          }
        })
      })
      this.chooseGroup.forEach((item, i) => {
        actualAmount += parseFloat(item.actualPrice)
      })
      console.log("验证实收金额：" + actualAmount.toFixed(2))
    }
  }
}
</script>

<style scoped>
.main {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
  overflow-x: hidden;
  background: #F5F5F5;
}

.name {
  width: 100%;
  display: flex;
  flex-flow: row;
  justify-content: center;
  background: #fff;
  padding: 20px 30px;
}

.group {
  padding-bottom: 10rem;
  height: calc(100vh - 81vw);
  overflow: scroll;
}

p {
  margin-top: 1.5rem;
}

.van-calendar__body {
  padding-bottom: 80px;
}


.plur-item-side {
  border-top-left-radius: 2rem;
}

.plur-item-main {
  border-top-right-radius: 2rem;
}

.plur-item-side .van-cell-group {
  background-color: #ecf1f5;
}

.plur-item-side .van-cell {
  background-color: transparent
}

.plur-item-side .van-cell-group.active {
  /*background-image: linear-gradient(to right, #10E3E9, #409EFF);*/
  background-color: #fff;
  color: #000;
  font-weight: bold;
  position: relative;
}

.plur-item-side .van-cell-group.active .van-cell {
  color: #000;
}

.plur-item-side .van-cell-group.active:before, .plur-item-side .van-cell-group.active:after {
  content: ' ';
  position: absolute;
  background: #ecf1f5;
  width: 1.2rem;
  height: 1.2rem;
  right: 0;
  z-index: 2;
  display: block;
}

.plur-item-side .van-cell-group.active:before {
  top: -1.2rem;
  border-bottom-right-radius: 100%;
}

.plur-item-side .van-cell-group.active:after {
  bottom: -1.2rem;
  border-top-right-radius: 100%;
}

.corner {
  width: 1.2rem;
  height: 1.2rem;
  position: absolute;
  background: #fff;
}

.bottom-corner {
  position: absolute;
  top: 100%;
  right: 0;
  z-index: 1;
}

.top-corner {
  position: absolute;
  bottom: 100%;
  right: 0;
}

.plur-item-side .van-cell:after {
  border-bottom: none;
}

.plur-item-side .van-cell {
  color: #737171;
}

.van-popup {
  background-clip: padding-box;
}


.order-dates {
  background: #fff;
  margin-top: 0.5rem;
}

.order-dates dt {
  font-size: 2rem;
  font-weight: bold;
  padding: 1.5rem;
  display: flex;
  font-weight: 500;
}

.order-dates dt .dt-right {
  font-size: 2.2rem;
  color: #969799;
}

.order-dates dt h3 {
  flex: 1;
}

.order-dates h3 {

}

.order-dates dd {
  padding-bottom: 1.5rem;
}

.order-dates ul {
  display: flex;
  font-size: 1.6rem;
  margin-left: 1rem;
  margin-right: 1rem;
}

.order-dates ul li {
  flex: 1;
  margin: 0 .3rem;
  background: #f1f5f9;
  text-align: center;
  padding-bottom: 1rem;
  border-radius: 1.5rem;
}

.order-dates ul li p {
  margin-top: .5rem;
  margin-bottom: .5rem;
}

.order-dates ul .day {
  color: gray;
}

.order-dates ul .week {
  font-size: 2rem;
  font-weight: bold;
}

.order-dates ul li.disabled .day, .order-dates ul li.disabled .week, .order-dates ul li.disabled .number {
  color: #d0d0d0;
}

.order-dates ul li.active {
  background-color: #1989fa;
}

.order-dates ul li.active .day, .order-dates ul li.active .week, .order-dates ul li.active .number {
  color: #fff;
}

/*预约日期是小于等于当天的不能约*/
.order-dates ul li.actived {
  background-color: #d5e1f9;
}

.order-times {
  margin-top: .2em;
  font-size: 2em;
  background: #f7f8fa;
  padding: 0 1em 1em 1em;
}

.order-times h3 {
  padding: 1.5rem 0;
}

.pdr10 {
  padding-right: 1em;
  text-align: left;
  font-size: .8em
}

.overlay-in {
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}

.overlay-in .overlay-text {
  padding: 2em;
  font-size: 2.4em;
  text-align: center;
}

.overlay-in .overlay-text h3 {
  font-size: 1.6em;
}

.overlay-interval {
  background-color: #ffffff;
}

/*二维码*/
#qqq {
  /* background-color: #111; */
  width: 300px;
  height: 300px;
  margin: 0 auto; /*水平居中*/
  position: relative;
}

.qrCode {
  display: inline-block;
  margin: 14px auto;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-100px, -100px);
}

.qrCode img {
  width: 200px;
  height: 200px;
  background-color: #fff;
  padding: 6px;
}

.vue-qr-code {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-bottom: 220px;
}

.vue-qr-text {
  font-size: 3em;
}

.package-item {
  width: 100%;
  /*height: 12rem;*/
  background: #fff;
  border-radius: 10px;
  margin-bottom: 1.5rem;
  display: flex;
  flex-flow: row;
  justify-content: center;
  /*box-shadow: 0 0 1.5rem #f5f5f5;*/
}

.package-group-list dl {
  padding: .5em .5em;
  line-height: 3.5em;
  margin: 1em 2em;
}

.package-group-list dl dt {
  color: #333;
  font-size: 2.2em;
}

.package-group-list dl dd {
  font-size: 2em;
  color: #999;
}

.package-group-list dt.text-decoration {
  text-decoration: line-through;
  color: #ff6c6c;
}

.van-goods-price {
  font-size: 2em;
  color: orangered;
  padding-left: .5em;
  padding-right: .5em;
}

.goods-price-text {
  color: #000
}

.goods-price-int {
  font-size: 2.1em;
}

/*小球*/
.ball {
  position: fixed;
  bottom: 40px;
  right: -140px;
  width: 2rem;
  height: 2rem;
  transition: all 1000ms cubic-bezier(0.000, 0.600, 0.940, 0.270);
  z-index: 9;
}

.innerBall {
  width: 2rem;
  height: 2rem;
  transition: all 1s linear;
}
</style>
